export default {
    authHeaderPrefix: "Bearer "
};

export const UploadConfig = {
    maxFileUploadSize: 10240,
    maxFileUploadinMB: "10 MB"
};